// src/store/reducers/languageReducer.js
import store from "../store";

const initialState = {
    language: [],
    locale: 'pl' // Set initial language to polish
};

const languageReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_LANGUAGE':
            return {
                ...state,
                locale: action.payload
            };
        default:
            return state;
    }
};

export default languageReducer;